// plan-01 S04 + plan-10 S05: URL hash + query parsing — bible §31

export interface HashState {
  hash: string
  portal: boolean
  heatmap: string | null
  divine: string | null
  pulse48: boolean
  palimpsest: boolean
  stage: string | null
  broadcast: boolean
  broadcastDate: string | null
  nodes: boolean
  commune: string | null
  vague: string | null
  oracle: string | null
}

export interface QueryState {
  nopost: boolean
  quiet: boolean
  reboot: boolean
  stage: string | null
  paint: string | null
  pwa: boolean
  nodesOff: boolean
  broadcastOff: boolean
}

export function parseHash(): HashState {
  const raw = window.location.hash.slice(1)
  const result: HashState = {
    hash: raw,
    portal: false,
    heatmap: null,
    divine: null,
    pulse48: false,
    palimpsest: false,
    stage: null,
    broadcast: false,
    broadcastDate: null,
    nodes: false,
    commune: null,
    vague: null,
    oracle: null,
  }

  if (!raw) return result

  // plan-10: #stage=<spec> grammar
  if (raw.startsWith('stage=')) {
    result.stage = decodeURIComponent(raw.slice(6))
  } else if (raw === 'portal') {
    result.portal = true
  } else if (raw.startsWith('heatmap=')) {
    result.heatmap = decodeURIComponent(raw.slice(8))
  } else if (raw.startsWith('divine=')) {
    result.divine = decodeURIComponent(raw.slice(7))
  } else if (raw === '48') {
    result.pulse48 = true
  } else if (raw === 'palimpsest') {
    result.palimpsest = true
  } else if (raw === 'broadcast') {
    result.broadcast = true
  } else if (raw.startsWith('broadcast=')) {
    result.broadcast = true
    result.broadcastDate = decodeURIComponent(raw.slice(10))
  } else if (raw === 'nodes') {
    result.nodes = true
  } else if (raw.startsWith('commune=')) {
    result.commune = decodeURIComponent(raw.slice(8))
  } else if (raw === 'vague') {
    result.vague = ''
  } else if (raw.startsWith('vague=')) {
    result.vague = decodeURIComponent(raw.slice(6))
  } else if (raw === 'oracle') {
    result.oracle = ''
  } else if (raw.startsWith('oracle=')) {
    result.oracle = decodeURIComponent(raw.slice(7))
  }

  return result
}

export function parseQuery(): QueryState {
  const params = new URLSearchParams(window.location.search)
  return {
    nopost: params.get('nopost') === '1',
    quiet: params.get('quiet') === '1',
    reboot: params.get('reboot') === '1',
    stage: params.get('stage'),
    paint: params.get('paint'),
    pwa: params.get('pwa') === '1',
    nodesOff: params.get('nodes') === 'off',
    broadcastOff: params.get('broadcast') === 'off',
  }
}
